<template>
  <v-toolbar class="escalon-dialog-header" elevation="0" height="35">
    <img
      class="modal-axis-logo mr-2"
      src="../../assets/AXIS Logo for Dark Backgrounds - Cropped - Grayscale.png">
    <span>Video Player</span>
    <v-spacer/>
    <span v-if="showHeader">{{patientHeader}}</span>
    <v-spacer/>
    <close-button @click.stop.prevent="$emit('closeModal')" />
  </v-toolbar>
</template>

<script>
import { mapGetters } from "vuex";
import closeButton from "../controls/CloseButton";
export default {
  name: "videoPlayerHeader",
  components: { closeButton },
  computed: {
  ...mapGetters(["patient", "videoViewer"]),
    showHeader() 
    {
      return this.videoViewer && !this.videoViewer.isKnowledgeCenterVideo;
    },
    patientHeader() {
      return this.patient && this.videoViewer && 
      (
        this.patient.ptId +
        " " +
        this.patient.lastName +
        ", " +
        this.patient.firstName + 
        " " + 
        this.videoViewer.exDevice + 
        " " + 
        this.videoViewer.exDateDisplay
      );
    }
  }
}
</script>
